import { FETCH_ALL_CATEGORIES } from '../actionTypes';

const initialState = null;

export default function(state = initialState, action=null){
  if(action.type ===FETCH_ALL_CATEGORIES) {
      return {
        ...state,
        ...action.payload
      };
  } else {
      return state;
  }
}




// WEBPACK FOOTER //
// ./src/store/reducers/categories.js